import config from '#core/config';
import g from '#core/global';
import load from '#core/load';
import cookie from '#core/cookie';
import util from '#core/util';
import expandable from '#partial/expandable/expandable';


// TODO: this could share some code with the modal, or vice versa

const cookie_prefix = 'alert_dismissed';
const cookie_value = '1';
const id_attr = 'id';
const delay_attr = 'data-alert-delay';
const days_attr = 'data-alert-days';
const alert_$ = '.alert';

let has_alert = false;
let $alert = null;
let $expandable = null;
let $close = null;
let days_between_showing = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('alert')) return false;
		
		load.content(() => {
			has_alert = assign_elements();
			if (!has_alert) return false;
			
			show();
		});
		load.all(() => {
			has_alert = assign_elements();
			if (!has_alert) return false;
		});
	}
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_alert) return true;
	
	$alert = document.querySelector(alert_$);
	if (!$alert) return false;
	
	$expandable = $alert.closest(expandable.container_$);
	days_between_showing = $alert.getAttribute(days_attr);
	
	$close = $alert.querySelector(expandable.close_$);
	if ($close) {
		$close.addEventListener(g.click_e, e => {
			dismiss();
		});
	}

	return true;
}


/**
 * Show alert
 */
function show() {
	const alert_id = $expandable.id;
	const cookie_name = get_cookie_name(alert_id);
	if (has_cookie(cookie_name)) return false;
	
	// TODO: a minimum delay is necessary to allow the expandable transition to
	// fire an event when done, otherwise it's shown without a transition and the
	// callback never fires
	let delay = parseInt($alert.getAttribute(delay_attr)) || 0;
	delay = Math.max(delay, 0.5) * 1000;
	
	setTimeout(() => {
		expandable.toggle({
			id: alert_id,
			force: true,
		});
	}, delay);
}


/**
 * Dismiss alert
 */
function dismiss() {
	const alert_id = $expandable.id;
	const cookie_name = get_cookie_name(alert_id);
	cookie.create(cookie_name, cookie_value, days_between_showing);
	
	expandable.toggle({
		id: alert_id,
		force: false,
	});
}


/**
 * Evaluate cookie to determine if alert should be shown
 * @param {string} cookie_name
 * @return {boolean}
 */
function has_cookie(cookie_name) {
	const alert_cookie = cookie.read(cookie_name);
	return alert_cookie === cookie_value;
}


/**
 * Get cookie name
 * @param {string} id
 * @return {string}
 */
function get_cookie_name(id) {
	return util.snake(`${config.site_name}_${cookie_prefix}_${id}`);
}
